import { render, staticRenderFns } from "./OvertimeType.vue?vue&type=template&id=622c62fd"
import script from "./OvertimeType.vue?vue&type=script&lang=js"
export * from "./OvertimeType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports